<mat-card class="block">
  <mat-card-content class="!pt-5">
    <div class="flex flex-wrap items-start justify-between gap-4 mb-1">
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2">
          <mat-icon>event_repeat</mat-icon>
          <span class="font-medium">{{ 'waters.price-lists.heading' | translate }}</span>
        </div>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ 'waters.price-lists.hint' | translate }}</p>
      </div>
      <app-add-price-list-button [waterId]="waterId()" [disabled]="isBusy()" (created)="onCreated()" />
    </div>

    @if (isLoading() && priceLists().length === 0) {
      <div class="py-6 flex justify-center">
        <mat-spinner diameter="32" />
      </div>
    } @else if (loadFailed()) {
      <!-- Distinct from the empty state below: the price lists could not be read, which says nothing about
           whether this lake has any. Nothing retries by itself, so the way out is offered here. -->
      <div class="py-2">
        <p class="text-gray-500 dark:text-gray-400">{{ 'waters.price-lists.load-failed-hint' | translate }}</p>
        <button mat-stroked-button type="button" class="mt-2" (click)="retryLoad()">
          {{ 'waters.price-lists.retry' | translate }}
        </button>
      </div>
    } @else if (priceLists().length === 0) {
      <p class="text-gray-500 dark:text-gray-400 py-2">{{ 'waters.price-lists.empty' | translate }}</p>
    } @else {
      <div class="overflow-x-auto mt-3">
        <table mat-table [dataSource]="priceLists()" class="w-full">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'waters.price-lists.field.name' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-medium">{{ row.name }}</span>
              <!-- Which list the backend prices from today, and which are staged ahead of it: the whole
                   point of a dated price list is that only one of them is live. -->
              @if (row.id === activePriceListId()) {
                <span
                  class="ml-2 align-middle text-xs rounded-full px-2 py-0.5 bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100">
                  {{ 'waters.price-lists.in-effect' | translate }}
                </span>
              } @else if (isFuture(row)) {
                <span
                  class="ml-2 align-middle text-xs rounded-full px-2 py-0.5 bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100">
                  {{ 'waters.price-lists.upcoming' | translate }}
                </span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef>{{ 'waters.price-lists.field.start-date' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.startDate | date: 'dd-MM-yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="text-right whitespace-nowrap">
              <button
                mat-icon-button
                type="button"
                [disabled]="isBusy()"
                [matTooltip]="'waters.price-lists.edit' | translate"
                (click)="edit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [disabled]="isBusy()"
                [matTooltip]="'waters.price-lists.delete' | translate"
                (click)="delete(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }
  </mat-card-content>
</mat-card>
